// extracted by css-extract-rspack-plugin
export default {"sectionHeading":"_96c89b68","sectionBody":"_b942c270","section":"_2f335940"};